<template>
    <div class="textual-address">
        <strong>
            {{address.calle}}
            #{{address.numero}}
            <span v-if="!!address.numero_interior">{{address.numero_interior}}</span>
            Col: {{address.colonia}}, {{address.asides.municipio}}, {{address.asides.estado}}. CP: {{address.codigo_postal}}
        </strong>
        <template v-if="!!address.referencia">
            <br>
            <small>
                Referencia: 
                {{address.referencia}}
            </small>
        </template>
    </div>
</template>

<script>
export default {
    name: 'textualAddress',
    props: {
        address: {
            type: Object,
            required: true
        }
    }
}
</script>